export default "__VITE_ASSET__CgJS$zxw__"